module.exports = __webpack_public_path__ + "static/media/nestje6.5b30db4b.webp";